import React from 'react';
import '../about.css';

const aboutData = [
    {
    tag: "Our Story",
    titleNormal: "Built on Passion.",
    titleAccent: "Driven by Purpose.",
    textParagraphs: [
        "Founded over 15 years ago, DLC Home Builders has established itself as a premier custom home builder in Chicago.",
        "Our journey began with a simple vision: to create exceptional homes that reflect the unique personality and lifestyle of each client."
    ],
    image: "../images/about_dlc-team_img.png",
    reverse: false
    },
    {
    tag: "Our Approach",
    titleNormal: "More Than Construction.",
    titleAccent: "It's a Commitment.",
    textParagraphs: [
        "We believe that building a home is more than construction—it's about bringing dreams to life.",
        "Our comprehensive approach combines innovative design, quality craftsmanship, and transparent communication to ensure every project exceeds expectations."
    ],
    image: "../images/team_2.jfif",
    reverse: true
    }
];

const AboutSection = () => {
    return (
    <section className="about-container">
        <div className="inner-max-width">
        {aboutData.map((item, index) => (
            <div key={index} className={`about-row ${item.reverse ? 'row-reverse' : ''}`}>
            
            {/* Text Column */}
            <div className="about-text-col">
                <span className="about-tag">{item.tag}</span>
                <h2 className="about-title">
                {item.titleNormal}<br />
                <span>{item.titleAccent}</span>
                </h2>
                {item.textParagraphs.map((para, pIndex) => (
                <p key={pIndex} className="about-p">{para}</p>
                ))}
            </div>
            
            {/* Image Column */}
            <div className="about-image-col">
                <div className="image-wrapper">
                <img src={item.image} alt={item.tag} />
                </div>
            </div>

            </div>
        ))}
        </div>
    </section>
    );
};

export default AboutSection;